export default __webpack_public_path__ + "static/media/Dark Heart.212579b1.jpg";